// extracted by mini-css-extract-plugin
export default {"container":"TenantEdit_container__cUFEo"};